import { combineReducers } from "redux";
import { createSelector } from "reselect";
import { routerReducer as routing } from "react-router-redux";
import { isEmpty } from "../helpers/functional";
import globalModal from "./globalModalReducer";
import globalNotification from "./globalNotificationReducer";
import {
  clubUserLoggedInReducer as clubUserLoggedIn,
  clubUserDataReducer as clubUserData,
  clubPricesInterestingReducer as clubPricesInteresting
} from "./discountClubReducer";
import lang from "./langReducer";
import viewDirection from "./viewDirectionReducer";
import isfetchingRooms from "./isfetchingRoomsReducer";
import * as roomResultsReducer from "./roomResultsReducer";
import * as fromRatesReducer from "./ratesReducer";
import { regionResultsReducer as regionResults } from "./regionResultsReducer";
import isFetchingRegionResults from "./isFetchingRegionResultsReducer";
import {
  selectedHotelIdReducer as selectedHotelId,
  selectedRegionIdReducer as selectedRegionId,
  selectedCityCodeReducer as selectedCityCode,
  selectedDealIdReducer as selectedDealId
} from "./hotelsReducer";
import {
  paxListReducer as paxList,
  selectedPaxIdReducer as selectedPaxId,
  singlePaxLoadedReducer as singlePaxLoaded
} from "./paxReducer";
import {
  checkinDateReducer as checkinDate,
  checkoutDateReducer as checkoutDate,
  flexibleDatesReducer as flexibleDates
} from "./datesReducer";
import { visibleCartReducer as visibleCart } from "./cartReducer";
import isMobileView from "./mobileViewReducer";
import contactUsSubmitingStatus from "./contactUsReducer";
import {
  currenciesReducer as currencies,
  selectedCurrencyReducer as selectedCurrency
} from "./currenciesReducer";
import {
  addonsReducer as addons,
  addonImagesLookupTableReducer as addonImagesLookupTable,
  selectedAddonsGroupReducer as selectedAddonsGroup,
  addonsForOrderReducer as addonsForOrder,
  addonsCurosselRoomNumberReducer as addonsCurosselRoomNumber
} from "./addonsReducer";
import {
  promoCodeReducer as promoCode,
  isPromoCodeValidReducer as isPromoCodeValid
} from "./promoCodeReducer";
import {
  dealsReducer as deals,
  dealDetailsReducer as deal,
  dealSearchResultsReducer as dealSearchResults,
  setDealMode as isDealMode,
  hasDealResultsReducer as hasDealResults
} from "./dealsReducer";

import { searchBoxModalOpenReducer as isSearchboxModalOpen } from "./generalReducers";

import { isIEReducer as isIE } from "./browserReducer";
import { isIosReducer as isIos } from "./OperationSystemReducer";
import isFetchingDealsResults from "./isFetchingDealsResultsReducer";
import isFetchingDealsSearchResults from "./isFetchingDealsSearchResultsReducer";
import isDealAnimationActive from "./isDealAnimationActive";
import searchDataTimestamp from "./searchDataTimestampReducer";
import selectedOption from "./selectedOptionReducer";
import selectedRoomCategory from "./selectedRoomCategoryReducer";
import {
  countriesReducer as countries,
  selectedCountryReducer as selectedCountry
} from "./countriesReducer";
import {
  registrationData,
  totalAmountToPay,
  totalClubAmountToPay,
  orderCurrency
} from "./registrationReducer";
import registrationSubmitingStatus from "./registrationSubmitingStatus";
import isFetchingConfirmationData from "./isFetchingConfirmationData";
import {
  payment,
  paymentUrlRequestStatus,
  reservationId,
  redirectURL
} from "./paymentReducer";
import paymentFinished from "./paymentFinishedReducer";
import orderSummary from "./orderSummaryReducer";
import isFetchingPaymentData from "./isFetchingPaymentData";
import { activeBreadCrumbReducer as activeBreadCrumb } from "./breadCrumbsReducer";
import { thumbnailDisplayReducer as thumbanilDisplay } from "./thumbnailDisplayReducer";
import {
  domainUrlReducer as domainUrl,
  enableAddonsPopUpReducer as enableAddonsPopUp,
  enableAddonsRegistrationReducer as enableAddonsRegistration,
  showCartSubmitBtnReducer as showCartSubmitBtn,
  chainHotelsReducer as chainHotels,
  lastMinuteDaysDealReducer as lastMinuteDaysDeal,
  showHotDealReducer as showHotDeal,
  discountClubConfigReducer as discountClubConfig,
  hotelDataReducer as hotelData,
  sortRatesByDefaultReducer as sortRatesByDefault,
  showContactDetailsInRegistrationReducer as showContactDetailsInRegistration,
  registrationModelReducer as registrationModel,
  registrationModelContactReducer as registrationModelContact,
  showThumbnailDisplayReducer as showThumbnailDisplay,
  numRoomsToSwitchToThumnailDisplayReducer as numRoomsToSwitchToThumnailDisplay,
  serverConfigReducer as serverConfig,
  showAvailabilityReducer as showAvailability,
  lowAvailabilityCountReducer as lowAvailabilityCount,
  ShowCancellationPolicyReducer as ShowCancellationPolicy,
  titlesReducer as titles,
  termsAndConditionsReducer as termsAndConditions,
  bookingRatesReducer as bookingRates,
  bookingRatesEnabledReducer as bookingRatesEnabled,
  isNoPaymentReducer as isNoPayment,
  singlePaxCartSkippingReducer as enableSinglePaxCartSkipping,
  propertyTypeReducer as propertyType,
  propertyTypePluralReducer as propertyTypePlural,
  allwayShowInRoomUnderRoomDisplayReducer as allwayShowInRoomUnderRoomDisplay,
  ShowViewExpandedByDefaultReducer as ShowViewExpandedByDefault,
  DisplayPriceWithoutTaxesReducer as displayPriceWithoutTaxes,
  TaxesPrecentageReducer as taxesPrecentage,
  showPricePerNightThumbReducer as showPricePerNightThumb,
  excludedTaxAtHotelReducer as excludedTaxAtHotel,
  enablePrePaymentReducer as enablePrePayment
} from "./configReducer";
import {
  placeHoldersReducer as placeHolders,
  analyticsPlaceHoldersReducer as analyticsPlaceHolders
} from "./placeHoldersReducer";
import { expandbleViewReducer as expandbleView } from "./expandbleViewReducer";
import {
  roomFilterReducer as roomFilter,
  planFilterReducer as planFilter,
  maxPriceRangeFilterReducer as maxPriceRangeFilter,
  minPriceRangeFilterReducer as minPriceRangeFilter,
  hotelFilterReducer as hotelFilter,
  regionFilterReducer as regionFilter
} from "./filtersReducer";
import userComments from "./userCommentsReducer";
import {
  alternativeSearchReducer as alternativeSearch,
  alternativeSearchErrorMessageReducer as alternativeSearchErrorMessage
} from "./alternativeSearchReducer";

const {
  // destructure in order to use the wildcard import and escape the eslint error of duplicate imports
  //roomsReducer: rooms,
  roomsByRequestDescriptor: rooms,
  displayRoomIdReducer: displayRoomId,
  getFirstRoomBySortOrder
} = roomResultsReducer;

const rootReducer = combineReducers({
  lang,
  titles,
  serverConfig,
  hotelData,
  chainHotels,
  promoCode,
  isPromoCodeValid,
  globalModal,
  globalNotification,
  discountClubConfig,
  clubUserLoggedIn,
  clubUserData,
  clubPricesInteresting,
  showAvailability,
  lowAvailabilityCount,
  viewDirection,
  isMobileView,
  routing,
  regionResults,
  isFetchingRegionResults,
  rooms,
  addons,
  addonImagesLookupTable,
  selectedAddonsGroup,
  enableAddonsPopUp,
  enableAddonsRegistration,
  addonsForOrder,
  addonsCurosselRoomNumber,
  sortRatesByDefault,
  isfetchingRooms,
  displayRoomId,
  paxList,
  checkinDate,
  checkoutDate,
  selectedHotelId,
  selectedRegionId,
  selectedCityCode,
  selectedDealId,
  visibleCart,
  showCartSubmitBtn,
  selectedPaxId,
  //ignoreClubDueToPromoCode,
  enableSinglePaxCartSkipping,
  singlePaxLoaded,
  searchDataTimestamp,
  selectedOption,
  deals,
  deal,
  isIE,
  isIos,
  isFetchingDealsResults,
  isFetchingDealsSearchResults,
  isDealAnimationActive,
  isNoPayment,
  dealSearchResults,
  isDealMode,
  hasDealResults,
  ShowCancellationPolicy,
  selectedRoomCategory,
  contactUsSubmitingStatus,
  currencies,
  selectedCurrency,
  countries,
  selectedCountry,
  termsAndConditions,
  bookingRates,
  bookingRatesEnabled,
  registrationData,
  registrationModel,
  registrationSubmitingStatus,
  payment,
  paymentUrlRequestStatus,
  paymentFinished,
  orderSummary,
  reservationId,
  isFetchingConfirmationData,
  totalAmountToPay,
  totalClubAmountToPay,
  orderCurrency,
  isFetchingPaymentData,
  activeBreadCrumb,
  registrationModelContact,
  showContactDetailsInRegistration,
  lastMinuteDaysDeal,
  showHotDeal,
  domainUrl,
  showThumbnailDisplay,
  numRoomsToSwitchToThumnailDisplay,
  allwayShowInRoomUnderRoomDisplay,
  isSearchboxModalOpen,
  propertyType,
  propertyTypePlural,
  thumbanilDisplay,
  placeHolders,
  analyticsPlaceHolders,
  expandbleView,
  ShowViewExpandedByDefault,
  roomFilter,
  planFilter,
  maxPriceRangeFilter,
  minPriceRangeFilter,
  hotelFilter,
  regionFilter,
  userComments,
  displayPriceWithoutTaxes,
  taxesPrecentage,
  showPricePerNightThumb,
  excludedTaxAtHotel,
  redirectURL,
  flexibleDates,
  alternativeSearch,
  alternativeSearchErrorMessage,
  enablePrePayment
});

export default rootReducer;

export const getFirstRoomBySortOrderSelector = getFirstRoomBySortOrder;

export const isRTL = state => state.viewDirection === "rtl";

export const selectedType = state => {
  const {
    selectedRegionId,
    selectedCityCode,
    selectedHotelId,
    selectedDealId
  } = state;
  let result = "Default";

  if (selectedHotelId) result = "Hotel";
  else if (selectedRegionId) result = "Region";
  else if (selectedCityCode) result = "City";
  else if (selectedDealId) result = "Deal";

  return result;
};

export const availablePaxList = ({
  paxList,
  rooms,
  isDealMode,
  dealSearchResults
}) =>
  paxList.filter(pax =>
    hasResultsforPax(rooms, pax.id, isDealMode, dealSearchResults)
  );

/* --- internal and public memoized selectors --- */
const getRoomByIdAndDescriptorSelector = (state, id, descriptor) =>
  roomResultsReducer.getRoomByIdAndDescriptor(state, id, descriptor);
const getRoomByIdAndDescriptor = createSelector(
  getRoomByIdAndDescriptorSelector,
  room => room
);

const getRateByIdSelector = (state, id) =>
  fromRatesReducer.getRateById(state, id);
const getRateById = createSelector(getRateByIdSelector, rate => rate);

export const hasResultsforPax = (
  rooms,
  paxId,
  isDealMode,
  dealSearchResults
) => {
  if (!isDealMode) {
    return rooms && rooms[paxId] && rooms[paxId].length > 0;
  } else {
    return (
      dealSearchResults &&
      dealSearchResults[paxId] &&
      dealSearchResults[paxId].length > 0
    );
  }
};

const sumTotalPriceOfAddons = selectedAddons => {
  return selectedAddons.reduce((acc, next) => {
    acc += next.price * next.amount;
    return acc;
  }, 0);
};

export const getCartTotalPrices = (state, isClubPrices) =>
  Object.entries(getSelectedDataForPax(state)).reduce(
    (accr, [, data]) => {
      const { rate, selectedAddons } = data;
      if (rate) {
        accr.roomsPrice += isClubPrices
          ? rate.simpleClubTotalPrice
          : rate.totalPrice;
        accr.roomsNoClubPrice += rate.totalPrice;

        if (selectedAddons) {
          accr.addonsPrice += sumTotalPriceOfAddons(selectedAddons);
        }
        accr.totalPrice = accr.roomsPrice + accr.addonsPrice;

        accr.roomsPrice = Math.round(accr.roomsPrice);
        accr.roomsNoClubPrice = Math.round(accr.roomsNoClubPrice);
        accr.addonsPrice = Math.round(accr.addonsPrice);
        accr.totalPrice = Math.round(accr.totalPrice);
      }

      return accr;
    },
    { addonsPrice: 0, roomsPrice: 0, roomsNoClubPrice: 0, totalPrice: 0 }
  );

export const getGlobalCurrency = state =>
  Object.entries(getSelectedDataForPax(state)).reduce((acc, [, data]) => {
    const { rate } = data;
    if (rate) {
      acc = rate.currency;
    }
    return acc;
  }, "");

export const getGlobalCurrencyCode = state =>
  Object.entries(getSelectedDataForPax(state)).reduce((acc, [, data]) => {
    const { rate } = data;
    if (rate) {
      acc = rate.currencyCode;
    }
    return acc;
  }, "");

export const getSumOfSelectedRates = state =>
  Object.entries(getSelectedDataForPax(state)).reduce((acc, [, data]) => {
    const { rate } = data;
    if (rate) {
      acc++;
    }
    return acc;
  }, 0);

const mapSelectedAddonsToAddons = (state, selectedIndex) => {
  const { selectedAddonsGroup, addons } = state;
  if (
    isEmpty(selectedAddonsGroup) ||
    !selectedAddonsGroup[selectedIndex] ||
    isEmpty(addons)
  )
    return null;
  const result = Object.entries(selectedAddonsGroup[selectedIndex]).map(
    ([addonKey, addonamount]) => {
      const currentAddon = addons[selectedIndex].find(
        addon => addon.id === addonKey
      );
      return {
        ...currentAddon,
        amount: addonamount
      };
    }
  );
  return result;
};

const getRoomByIdAndDescriptorDeals = (deals, rateId, requestDescriptor) => {
  const room =
    deals &&
    deals[requestDescriptor] &&
    deals[requestDescriptor].find(
      deal => (deal.rate ? deal.rate.id === rateId : false)
    );
  return room;
};

const getSelectedDataForPaxSelector = state => {
  const { rooms, paxList, dealSearchResults, isDealMode } = state;
  const selectedDataForPax = paxList.reduce((acc, p) => {
    const room = !isDealMode
      ? getRoomByIdAndDescriptor(rooms, p.roomId, p.id)
      : getRoomByIdAndDescriptorDeals(dealSearchResults, p.rateId, p.id);
    const rate = !isDealMode
      ? room && getRateById(room.rates, p.rateId)
      : room && room.rate;
    const selectedAddons = mapSelectedAddonsToAddons(state, p.id);
    acc[p.id] = {
      id: p.id,
      room,
      rate,
      selectedAddons
    };
    return acc;
  }, {});
  return selectedDataForPax;
};

export const getSelectedDataForPax = createSelector(
  getSelectedDataForPaxSelector,
  selectedDataForPax => selectedDataForPax
);

const getRoomsPerPaxSelector = state => {
  const { rooms } = state;
  const currentPax = getCurrentPaxCombinationSelector(state);
  const currentPaxId = (currentPax && currentPax.id) || 0;
  return rooms && rooms[currentPaxId];
};
export const getRoomsPerPax = createSelector(
  getRoomsPerPaxSelector,
  //roomsPerPax => roomsPerPax && [roomsPerPax[0]]
  roomsPerPax => roomsPerPax
);

const getCurrentPaxCombinationSelector = state => {
  const { paxList, selectedPaxId } = state;
  return paxList.find(p => p.id === selectedPaxId) || paxList[0];
};
export const getCurrentPaxCombination = createSelector(
  getCurrentPaxCombinationSelector,
  paxCombination => paxCombination
);

const getSelectedRoomIdSelector = state => {
  const { displayRoomId } = state;
  const roomsPerPax = getRoomsPerPax(state);
  const currentPaxCombination = getCurrentPaxCombination(state);
  const selectedRoomId =
    displayRoomId || (currentPaxCombination && currentPaxCombination.roomId);
  const firstRoom = roomsPerPax && getFirstRoomBySortOrderSelector(roomsPerPax);
  const defaultRoomId = firstRoom && firstRoom.id;
  return selectedRoomId || defaultRoomId;
};
export const getSelectedRoomId = createSelector(
  getSelectedRoomIdSelector,
  selectedRoomId => selectedRoomId
);

const getRoomToDisplaySelector = state => {
  const roomsPerPax = getRoomsPerPax(state);
  const selectedRoomId = getSelectedRoomId(state);
  const selectedRoomToDisplay =
    roomsPerPax && roomsPerPax.find(room => room.id === selectedRoomId);
  const defaultRoom =
    roomsPerPax &&
    roomsPerPax.find(room => room.requestDescriptor === state.selectedPaxId);
  return selectedRoomToDisplay || defaultRoom;
};

export const getRoomToDisplay = createSelector(
  getRoomToDisplaySelector,
  selectedRoomToDisplay => selectedRoomToDisplay
);

export const getSinglePaxAndSelectedFlag = state => {
  const sumOfSelectedRates = getSumOfSelectedRates(state);
  const { paxList } = state;
  const allPaxSelected = sumOfSelectedRates == paxList.length;
  const isSinglePax = paxList.length == 1;
  return allPaxSelected && isSinglePax;
};

export const filteredAvailableRates = createSelector(
  fromRatesReducer.filteredAvailableRates,
  filteredAvailableRates => filteredAvailableRates
);

const getSelectedHotelNameSelector = state => {
  const { selectedHotelId, chainHotels } = state;
  const selectedHotelFromChains = chainHotels.find(
    h => h.id.toString().trim() === selectedHotelId.trim()
  );
  return selectedHotelFromChains && selectedHotelFromChains.name;
};

export const getSelectedHotelName = createSelector(
  getSelectedHotelNameSelector,
  hotelName => hotelName
);



// WEBPACK FOOTER //
// ./src/reducers/index.js